// extracted by mini-css-extract-plugin
module.exports = {"Adventure":"Adventure_Adventure__22_fE"};